import React, { useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom"
import { FaCheckCircle } from "react-icons/fa"
import { QRCodeSVG } from "qrcode.react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { Button } from "components"
import classes from "./KpSuccess.module.scss"

const KpSuccess = (props) => {
  const { title, link, onRedirect = () => { } } = props

  const { domain, subdomain, customDomainName } =
    useSelector(state => state.systemSettings)

  const [t] = useTranslation()

  const [count, setCount] = useState(30)

  const timeout = useRef()

  const timer = useRef()

  const history = useHistory()

  const handleGo = () => {
    onRedirect()

    clearTimeout(timeout.current)

    clearTimeout(timer.current)

    history.push("/kiosk-languages")
  }

  const handleCountDown = () => {
    setCount(prev => {
      prev = prev - 1

      return prev || 0
    })
  }

  useEffect(() => {
    timeout.current =
      setTimeout(() => handleGo(), 30 * 1000)

    timer.current =
      setInterval(() => handleCountDown(), 1000)

    return () => { clearTimeout(timeout.current) }
  }, [])

  const url =
    !!customDomainName
      ? `https://${customDomainName}/pager/${link}`
      : `https://${subdomain}.${domain}/pager/${link}`

  return (
    <div className={classes["container"]}>
      <FaCheckCircle color="white" size={150} />

      <h1 className={classes["title"]}>
        {title}
      </h1>

      <h2 className={classes["subtitle"]}>
        {t("جهت رهگیری سفارش کد QR زیر را اسکن کنید")}.
      </h2>

      <div className={classes["center"]}>
        <QRCodeSVG
          size={450}
          value={url}
          bgColor="transparent"
        />
      </div>

      <h3 className={classes["subtitle"]}>
        {t("این کد در رسید شما نیز چاپ می شود")}.
      </h3>

      <div className={classes["footer"]}>
        <Button
          onClick={handleGo}
          className={classes["button"]}
        >
          {t("بازگشت به صفحه اصلی")} ({count})
        </Button>
      </div>
    </div>
  )
}

export default KpSuccess